export const PRINTFUL_PRODUCT_VARIANTS_FIELDS_LIST: any = [
    {attribute: "id", label: "Id", cssClass: ''},
    {attribute: "productTitle", label: "Product", cssClass: ''},
    {attribute: "name", label: "Variant", cssClass: ''},
    // {attribute: "product_id", label: "Product Id", cssClass: ''},
    {attribute: "size", label: "Size", cssClass: ''},
    {attribute: "color", label: "Color", cssClass: ''},
    // {attribute: "color_code", label: "Color Code", cssClass: ''},
    {attribute: "price", label: "Price", cssClass: ''},
];


export const PRINTFUL_PRODUCT_VARIANTS_INPUT_FIELDS: any = [
    {attribute: "id", label: "Id", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "name", label: "Variant Name", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "productId", label: "Product Id", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "size", label: "Size", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "color", label: "Color", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "colorCode", label: "Color Code", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "", label: "", type: 'text', group: 'detail', cssClass: ''},
];
